module.exports = __webpack_public_path__ + "img/fxyh.9d491ee3.png";